import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {getITProcessById} from '../../../../../../../selectors/ISA315/selectors';
import BodySpecialAccordionHeaderColumn from '../BodySpecialAccordionHeaderColumn';
import {getRelatedItRiskCount} from './commonCounters';

function ItProcessItItRiskCount({itProcessId, header, className}) {
	const itProcess = useSelector((state) => getITProcessById(state, itProcessId));
	const relatedItRiskCount = getRelatedItRiskCount(itProcess?.itRisks);

	return <StyledItProcessItRiskCount className={className} header={header} value={relatedItRiskCount || '-'} />;
}

ItProcessItItRiskCount.propTypes = {
	itProcessId: PropTypes.number.isRequired,
	header: PropTypes.string.isRequired,
	className: PropTypes.string
};

export default ItProcessItItRiskCount;

const StyledItProcessItRiskCount = styled(BodySpecialAccordionHeaderColumn)`
	width: var(--px-100);
`;
